import { useLocation } from "react-router";
import { Link as RouterLink } from "react-router";
import styled from "styled-components";

const StyledLink = styled(RouterLink)`
  text-decoration: none;
  color: #541299;

  :hover {
    text-decoration: underline;
  }
`;

const Link = ({ to, children, ...props }) => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  return (
    <StyledLink to={`${to}?${params.toString()}`} {...props}>
      {children}
    </StyledLink>
  );
};

export default Link;
